import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import {addToCart, clearCart, removeFromCart, restoreCart, updateCanvasCount} from "../../../actions/actionFunctions";
import {getCartItemObject} from "../../../misc/helpers";
import {
  createCartList,
  getMatchingColorFeature,
  navFeatureCLick
} from "../lookNavigation/lookFunctions";
import {setLookRemovedCartItems} from "../../../actions/shoppingCartFunctions";
import {
  featureIsBundle,
  getBundledFeatures,
  getCartItemsArrayFromFeature, getFeatureUrl,
} from "../lookNavigation/lookFunctions2";
import {getCurrentLayout} from "../../appLayout";
import {IS_LOOK_JOURNEY, IS_PRODUCT_JOURNEY} from "../../../config";
import {CART_ITEM_ADDED_BY} from "../../shoppingCart/cartItemInterface";
import {isFeatureNotInVisualizerNow} from "../../visComponents/featuresFunctions";

const WithUpdateLookCartItem = (props) => {

  const {cartItems, removeFromCart, addToCart, qtActiveCategory, lookActiveFeature, history, children, updateCanvasCount,
    lookRemovedCartItems, setLookRemovedCartItems, filterGroups, groheActiveFeatureQuantity,
    clearCart, restoreCart, fabricatorSettings} = props;

  /**
   * Creates cart items list depending on quotingTool features
   * @param neededFeature {featureInterface} current active updated feature
   * @param withAddToCart {boolean} should we add it to the cart (for product journey) or just update
   */
  const updateLookCartItem = (neededFeature = lookActiveFeature, withAddToCart = false) => {
    // if (!checkIfFeatureCanBeAddedToTheCart(neededFeature)) {
    //   return false
    // }

    return updateLookCartItemsNew(neededFeature, withAddToCart); // temp test, if everything is ok - remove redundant code below

    let itemsToAdd = [];
    // const urlPartId = neededFeature.partId.replace(/_/gi, "-");
    const layout = getCurrentLayout();
    const addedCartItems = cartItems.filter(cItem => {
      // if (featureGroup.layerPositions) {
      //   return (cItem.partId === neededFeature.partId)
      //     && (cItem.cartFeature.metaData.layerPosition === neededFeature.metaData.layerPosition)
      // }
      const parent = layout.getFeatureGroupByPartId(cItem.partId);
      if (!IS_PRODUCT_JOURNEY && parent && parent.disabled) { // remove these cartItems too
        return true
      }
      return cItem.partId === neededFeature.partId
    });
    if (addedCartItems.length && !IS_PRODUCT_JOURNEY) {
      addedCartItems.forEach(addedCartItem => {
        removeFromCart(addedCartItem);
        if (featureIsBundle(addedCartItem.cartFeature, cartItems)) {
          cartItems.forEach(cItem => {
            if (cItem.relatedProductParent && cItem.relatedProductParent.dbFeature.id === addedCartItem.cartFeature.dbFeature.id) {
              removeFromCart(cItem)
            }
          })
        }
      })
    }
    // let newQuantity = IS_PRODUCT_JOURNEY
    //   ? groheActiveFeatureQuantity
    //   : addedCartItems.length ? addedCartItems[0].quantity : 1;
    let newQuantity = groheActiveFeatureQuantity;
    if (neededFeature.metaData.layerPosition && !IS_PRODUCT_JOURNEY) {
      const featureGroup = neededFeature.getParent();
      Object.keys(featureGroup.layerPositions).forEach(position => {
        if (featureGroup.layerPositions[position]) {
          if (position !== neededFeature.metaData.layerPosition) {
            if (neededFeature.dbFeature.sharedFeatureName === featureGroup.layerPositions[position].dbFeature.sharedFeatureName) {
              if (newQuantity === 1) {
                newQuantity += 1
              }
            } else {
              // here we update cart with same partId, but different position (for now it should not be executed since we have all positions same)
              itemsToAdd.push(getCartItemObject(featureGroup.layerPositions[position], 1, qtActiveCategory));
              if (newQuantity > 1) {
                newQuantity--;
              }
            }
          }
        }
      });
      if (neededFeature.partId === "vanity_faucet") {
        const sinkParent = featureGroup.getParent().sink;
        const addedSinkItem = cartItems.find(cItem => {
          return cItem.partId === sinkParent.partId
        });
        if (addedSinkItem && addedSinkItem.cartFeature.dbFeature.sharedFeatureName && sinkParent.activeFeature && sinkParent.activeFeature.dbFeature.sharedFeatureName
          && (addedSinkItem.cartFeature.dbFeature.sharedFeatureName !== sinkParent.activeFeature.dbFeature.sharedFeatureName)) {
          // here we update cart with automatically changed feature (via the metadata)
          itemsToAdd.push(getCartItemObject(sinkParent.activeFeature, addedSinkItem.quantity, qtActiveCategory));
          removeFromCart(addedSinkItem);
        }
      }
    }
    itemsToAdd = [...itemsToAdd, ...getCartItemsArrayFromFeature(neededFeature, newQuantity, qtActiveCategory)]; // here we update cart with clicked feature

    if (!IS_PRODUCT_JOURNEY) {
      const featureGroups = getLookList(true);
      if (featureGroups && featureGroups.length) {
        let shouldBeAdded = [];
        featureGroups.forEach(parentObject => {
          if (parentObject.featureGroup.layerPositions) {
            Object.keys(parentObject.featureGroup.layerPositions).forEach(position => {
              if (parentObject.featureGroup.layerPositions[position]) {
                if (position !== neededFeature.metaData.layerPosition) {
                  if (neededFeature.dbFeature.sharedFeatureName === parentObject.featureGroup.layerPositions[position].dbFeature.sharedFeatureName) {
                    if (newQuantity === 1) {
                      newQuantity += 1
                    }
                  } else {
                    // here we update cart with same partId, but different position (for now it should not be executed since we have all positions same)
                    itemsToAdd.push(getCartItemObject(parentObject.featureGroup.layerPositions[position], 1, qtActiveCategory));
                    if (newQuantity > 1) {
                      newQuantity--;
                    }
                  }
                }
              }
            });
          }
        })
        itemsToAdd = [...itemsToAdd, ...shouldBeAdded]; // here we update cart with enabled but not added features
      }
    }

    addToCart(itemsToAdd);

    updateRemovedCartItems(itemsToAdd);
  }

  const updateRemovedCartItems = (itemsToAdd) => {
    if (lookRemovedCartItems.length) {
      let newRemovedCartItems = [...lookRemovedCartItems];
      itemsToAdd.forEach(cartItem => {
        const existingIndex = newRemovedCartItems.findIndex(removedCartItem => {
          if (cartItem.cartFeature.metaData.layerPosition) {
            return (removedCartItem.partId === cartItem.partId)
              && (cartItem.cartFeature.metaData.layerPosition === removedCartItem.cartFeature.metaData.layerPosition)
          }
          return removedCartItem.partId === cartItem.partId || (
            removedCartItem.relatedProductParent && removedCartItem.relatedProductParent.partId === cartItem.partId
          )
        });
        if (existingIndex > -1) {
          newRemovedCartItems.splice(existingIndex, 1);
        }
      });
      if (newRemovedCartItems.length !== lookRemovedCartItems.length) {
        setLookRemovedCartItems(newRemovedCartItems);
      }
    }
  }

  const updateLookCartItemsNew = (neededFeature, withAddToCart) => {

    clearCart();
    let itemsToAdd = createCartList(qtActiveCategory, null);
    itemsToAdd.forEach(currentCartItem => {
      const oldExistingCartItem = cartItems.find(cItem => cItem.partId === currentCartItem.partId);
      if (oldExistingCartItem && !IS_PRODUCT_JOURNEY) {
        currentCartItem.addedBy = oldExistingCartItem.addedBy; // if it was changed by user - keep it
        if (oldExistingCartItem.quantity > currentCartItem.quantity) {
          if (currentCartItem.cartFeature.getParent) {
            const parent = currentCartItem.cartFeature.getParent();
            if (parent.layerPositions) {
              currentCartItem.quantity = Object.keys(parent.layerPositions).filter(positionKey => parent.layerPositions[positionKey]).length
            } else {
              currentCartItem.quantity = oldExistingCartItem.quantity;
            }
          } else {
            currentCartItem.quantity = oldExistingCartItem.quantity;
          }
        }
      }
      if (IS_PRODUCT_JOURNEY && neededFeature && !isFeatureNotInVisualizerNow(neededFeature)) {
        if (currentCartItem.partId === neededFeature.partId
          || (currentCartItem.relatedProductParent
            && (currentCartItem.relatedProductParent.dbFeature.id === neededFeature.dbFeature.id))) {
          currentCartItem.quantity = groheActiveFeatureQuantity;
          if (withAddToCart) {
            currentCartItem.addedBy = CART_ITEM_ADDED_BY.user;
          }
        }
      }
    });
    if (neededFeature && isFeatureNotInVisualizerNow(neededFeature)) {
      const newCartItem = getCartItemObject(neededFeature, groheActiveFeatureQuantity, qtActiveCategory);
      newCartItem.addedBy = withAddToCart ? CART_ITEM_ADDED_BY.user : CART_ITEM_ADDED_BY.auto;
      itemsToAdd.push(newCartItem);
      // same bundled-features logic as createCartList: also add any features bundled with this one
      const relatedFeatures = getBundledFeatures(neededFeature);
      relatedFeatures.forEach((relatedFeature) => {
        const cartItem = getCartItemObject(relatedFeature, groheActiveFeatureQuantity, qtActiveCategory);
        cartItem.relatedProductParent = neededFeature;
        cartItem.addedBy = newCartItem.addedBy;
        itemsToAdd.push(cartItem);
      })
    }
    if (IS_PRODUCT_JOURNEY && fabricatorSettings.checkout) {
      itemsToAdd = [...itemsToAdd, ...cartItems].filter(cItem => cItem.addedBy === CART_ITEM_ADDED_BY.user); // keep old added cartItems!
    }
    if (fabricatorSettings.checkout) {
      cartItems.forEach(cItem => {
        if (!cItem.keepOnLookUpdate) {
          return
        }
        if (!itemsToAdd.some(itemToAdd => itemToAdd.id === cItem.id)) {
          itemsToAdd.push(cItem) // keep old added cartItems! that was added from wizard list for example
        }
      })
    }
    restoreCart({cartItems: itemsToAdd});
    updateRemovedCartItems(itemsToAdd);
  }

  /**
   * updates array of features
   * @param notMatchingFeatures {array}
   * @param fromFeature {featureInterface}
   * @param changeUrl {boolean}
   * @param directChange {boolean} // if only update
   */
  const updateAllLookCartItems = (notMatchingFeatures = [],
                                  fromFeature = lookActiveFeature,
                                  changeUrl = true,
                                  directChange = false) => {
    let needToBeUpdated = [fromFeature];
    if (notMatchingFeatures.length) {
      const currentFeatureName = fromFeature.getSplittedFeatureName();
      let toiletEnabled = false;
      notMatchingFeatures.forEach(notMatchingFeature => {
        if (notMatchingFeature.dbFeature.id !== fromFeature.dbFeature.id) {
          const sameFeatureAsActive = directChange ? {part: notMatchingFeature} : getMatchingColorFeature(fromFeature, notMatchingFeature, filterGroups)
          if (sameFeatureAsActive) {
            navFeatureCLick(sameFeatureAsActive.part, false);
            needToBeUpdated.push(sameFeatureAsActive.part);
            switch (sameFeatureAsActive.part.partId) {
              case "toilet_brush":
              case "paper_holder": {
                if (!toiletEnabled) {
                  const layout = getCurrentLayout();
                  const relatedFeatureGroup = layout.getFeatureGroupByPartId("toilet");
                  if (relatedFeatureGroup && relatedFeatureGroup.disabled && relatedFeatureGroup.activeFeature && !toiletEnabled) {
                    navFeatureCLick(relatedFeatureGroup.activeFeature, false);
                    needToBeUpdated.push(relatedFeatureGroup.activeFeature);
                  }
                }
                break;
              }
              default:
                break;
            }
          } else {
            console.log("sameFeatureAsActive not found", notMatchingFeature.partId, currentFeatureName);
          }
        }
      })
    }
    needToBeUpdated.forEach(featureToClick => {
      navFeatureCLick(featureToClick, false);
    });
    if (IS_LOOK_JOURNEY || IS_PRODUCT_JOURNEY) {
      updateLookCartItem(fromFeature); // don't add to cart on qkb ui
    }
    updateCanvasCount();
    // if (IS_PRODUCT_JOURNEY) {
    //   setLookActiveCategory("");
    // }
    // if (changeUrl && IS_PRODUCT_JOURNEY) {
    if (changeUrl) {
      history.push(getFeatureUrl(fromFeature, true));
    }
  }

  return children(updateLookCartItem, updateAllLookCartItems)
};

const mapStateToProps = (store) => {
  const {lookActiveFeature} = store.lookState;
  const {cartItems, lookRemovedCartItems} = store.cartState;
  const {qtActiveCategory} = store.qtState;
  const {filterGroups} = store.filterState;
  const {groheActiveFeatureQuantity} = store.groheState;
  const {settings} = store.fabricatorState;

  return {
    lookActiveFeature,
    cartItems,
    qtActiveCategory,
    lookRemovedCartItems,
    filterGroups,
    groheActiveFeatureQuantity,
    fabricatorSettings: settings,
  }
};

const mapDispatchToProps = {
  removeFromCart,
  addToCart,
  updateCanvasCount,
  setLookRemovedCartItems,
  clearCart,
  restoreCart
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithUpdateLookCartItem)
)
